const commonFunc = {
  name: "commonFunc",
  methods: {
    handlePaste(event) {
      const clipboardData = event.clipboardData;
      const pastedData = clipboardData.getData("Text");

      if (!/^\d*$/.test(pastedData)) {
        event.preventDefault();
      } else {
        // Sanitize the pasted input (numbers only)
        this.goToPage = pastedData.replace(/\D/g, "");
      }
    },
  },
};

export default commonFunc;
